module.exports = __webpack_public_path__ + "img/live-rtmp-tutorial-2.a3263450.png";